import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Input, Link, ProfileIcon } from "../../components";
import { LoginContainer } from "../login/LoginContainer";
import { validateEmail } from "../../validations/validations";
import { sendForgotPasswordRequest } from "../../services/password";

export const ForgottenPassword = () => {
  const [username, setUsername] = useState("");
  const [loginPagePath, setLoginPagePath] = useState<string>("/login");
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isEnableForgottenPassword = process.env.REACT_APP_ENABLE_FORGOTTEN_PASSWORD?.toLowerCase() ?? false;

  const usernameValidationMsg = (): string | null => {
    const isValidEmail = validateEmail(username);
    if (isValidEmail) {
      return null;
    }
    return t("passwordUsernameValidation");
  };

  useEffect(() => {
    const path = searchParams.get("redirect_uri");
    if (!isEnableForgottenPassword) {
      navigate("/signin");
      return;
    }
    if (path) {
      setLoginPagePath(path);
    }
    // eslint-disable-next-line
  }, [location, navigate]);

  const isUserNameInvalid = !(username && validateEmail(username)) || usernameValidationMsg() !== null;

  const sendEmail = async () => {
    setLoading(true);
    const data = {
      email: username,
      callback: loginPagePath?.split("callback=")[1] ? loginPagePath?.split("callback=")[1] : "",
    };
    const response = await sendForgotPasswordRequest(data);
    if (response === true) {
      navigate(loginPagePath, {
        state: { showForgottenPasswordMessage: true },
      });
    } else {
      setLoading(false);
    }
  };
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await sendEmail();
  };

  return (
    <LoginContainer>
      <form className="login-elements" onSubmit={handleSubmit}>
        <Input
          placeholder={t("loginUsername")}
          onChange={(e) => setUsername(e.target.value)}
          autofocus={true}
          validationMsg={usernameValidationMsg()}
          value={username}
          className="username-input"
          Icon={ProfileIcon}
        />
        <Button
          lKey={t("forgottenPasswordButtonText")}
          isDisabled={isUserNameInvalid}
          className="username-button"
          type="submit"
          isLoading={loading}
        />
        <Link className="link-text" isPointer={true} lKey={t("forgottenPasswordLinkText")} path={loginPagePath} />
      </form>
    </LoginContainer>
  );
};
